import { useState, useEffect } from 'react';
import type { ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
  className?: string;
}

export function PageTransition({ children, className }: PageTransitionProps) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const id = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(id);
  }, []);

  return (
    <div
      style={{
        opacity: ready ? 1 : 0,
        transform: ready ? 'none' : 'translateX(-20px)',
        transition: 'opacity 0.2s ease-out, transform 0.2s ease-out',
        // will-change: transform cree un containing block pour les descendants
        // en position:fixed (meme regle qu'un transform reel) : les DragOverlay
        // de dnd-kit se positionnaient par rapport a la page, pas au viewport
        // => drag tres decale du curseur. On le retire une fois l'animation
        // d'entree terminee.
        willChange: ready ? 'auto' : 'opacity, transform',
      }}
      // flex flex-col min-h-full : la transition est transparente pour les
      // pages qui veulent occuper toute la hauteur du <main> (h-full / flex-1).
      // Sans ça, les pages collapsent à la hauteur de leur contenu et les
      // menus déroulants en absolute débordent du conteneur scrollable.
      className={`flex flex-col h-full min-h-0 overflow-auto ${className ?? ''}`}
    >
      {children}
    </div>
  );
}
